export default __webpack_public_path__ + "static/media/classlink-icon.99bc859b.png";